'use client';
import React from 'react';
import Introduction from './Introduction';
import ArticlesOfAssociation from './ArticlesOfAssociation';
import BoardOfDirectors from './BoardOfDirectors';
import OtherInformation from './OtherInformation';
import { classes } from './utils';

export default function Page() {
  return (
    <div className={classes.wrapper}>
      <Introduction />
      <ArticlesOfAssociation />
      <BoardOfDirectors />
      <OtherInformation />
    </div>
  );
}
